import { auth, db, googleProvider } from "@/firebase/firebaseInit";
import { sendEmailVerification, signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { Timestamp, collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";

export default {
    setCurrentUser(context, user) {
        context.commit('setCurrentUser', user);
    },

    async login(context, payload) {
        await signInWithEmailAndPassword(auth, payload.email, payload.password)
            .then((userCredential) => {
                // Signed in
                const user = userCredential.user;
                console.log("LOGIN: email: '" + user.email + "' and auth.uid: '" + auth.currentUser.uid + "'");
                context.commit('setCurrentUserID', auth.currentUser.uid);
            })
            .catch((error) => {
                console.error("LOGIN! CODE:" + error.code + "; MESSAGE: " + error.message);
                throw new Error("Wrong email or password!");
            });
        await context.dispatch('loadUserProfile');
    },

    async loginWithGoogle(context) {
        const result = await signInWithPopup(auth, googleProvider);
        context.commit('setCurrentUserID', result.user.uid);
        await context.dispatch('loadUserProfile');
        const currentUser = context.state.currentUser;
        if (!currentUser || currentUser.id === 'USER_NOT_FOUND') {
            await context.dispatch('createUser', {
                name: result.user.displayName || '',
                email: result.user.email,
                phone: ''
            });
        }
    },

    async loadUserProfile(context) {
        console.log("LOAD USER: attempt to load user by auth.UID: " + auth.currentUser.uid);
        const queryByUid = await getDoc(doc(db, "users", auth.currentUser.uid));

        if (queryByUid.exists()) {
            // New user doc already created - all good!
            console.log("LOAD USER: user found by auth.UID");
            context.commit('setCurrentUser', queryByUid.data());
            context.commit('setCurrentUserID', queryByUid.id);
            return;
        } else {
            // First time login AFTER release of Security Rules v3.5.0
            console.log("LOAD USER: user NOT found by auth.UID");
            // Set dummy data in the session so that the page can continue loading
            // User doc will be created when the user updates the profile
            context.commit('setCurrentUser', {
                id: "USER_NOT_FOUND",
                email: auth.currentUser.email
            });
        }
        // Try to find user by email
        console.log("LOAD USER: attempt to load user by EMAIL: " + auth.currentUser.email);

        var queryByEmail = null;
        try {
            queryByEmail = await getDocs(query(collection(db, "users"), where("email", "==", auth.currentUser.email)));
        } catch (error) {
            throw new Error("Error finding existing user by email: " + auth.currentUser.email);
        }

        var user = {
            email: null,
            name: null,
            phone: null,
            role: null
        };

        queryByEmail.forEach((doc) => {
            // Existing user doc found
            console.log("LOAD USER: user found by EMAIL");
            if (doc.data().email) {
                user.email = doc.data().email
            }
            if (doc.data().name) {
                user.name = doc.data().name
            }
            if (doc.data().phone) {
                user.phone = doc.data().phone
            }
            if (doc.data().admin) {
                user.role = "admin"
            } else {
                user.role = "volunteer"
            }
            user.id = doc.id;
        });

        if (user.id) {
            // Recreate the user doc in the database using auth.UID
            await setDoc(doc(db, "users", auth.currentUser.uid), {
                name: user.name,
                email: user.email,
                phone: user.phone,
                role: user.role,
                old_id: user.id,
                created_at: Timestamp.fromDate(new Date())
            });
            console.log("LOAD USER: Recreated user doc with auth.UID");

            // Setting User data in session
            context.commit('setCurrentUser', user);
            context.commit('setCurrentUserID', auth.currentUser.uid);

            // Delete old doc
            console.log("LOAD USER: Deleting old doc with ID: " + user.id);
            await deleteDoc(doc(db, "users", user.id));
        } else {
            // A New User - recreation of user doc NOT required
            console.log("LOAD USER: user not found by EMAIL");
            context.commit('setCurrentUserID', auth.currentUser.uid);
        }
    },

    async createUser(context, payload) {
        console.log("CREATE USER: by auth.UID: " + auth.currentUser.uid);
        await setDoc(doc(db, "users", auth.currentUser.uid), {
            name: payload.name,
            email: payload.email,
            phone: payload.phone,
            role: "volunteer",
            created_at: Timestamp.fromDate(new Date())
        });
    },

    async resendVerificationEmail() {
        await sendEmailVerification(auth.currentUser);
    },

    async updateUser(context, payload) {
        const userRef = doc(db, 'users', payload.userID);
        const updates = {};
        if (payload.name !== undefined) {
            updates.name = payload.name;
        }
        if (payload.phone !== undefined) {
            updates.phone = payload.phone;
        }
        await updateDoc(userRef, updates);
    },

    async loadUserDataByID(context, payload) {
        const docRef = doc(db, 'users', payload);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            console.log("FIND USER: user found by ID: " + payload);
            context.commit('setUserData', docSnap.data());
        } else {
            console.log("FIND USER: user NOT found by ID: " + payload + ". Searching by old_id");
            const queryByOldId = await getDocs(query(collection(db, "users"), where("old_id", "==", payload)));
            queryByOldId.forEach((doc) => {
                // User found by old_id
                console.log("LOAD USER: user found by old_id");
                context.commit('setUserData', doc.data());
            });
            if (queryByOldId.empty) {
                context.commit('setUserData', null);
                throw new Error("User not found!");
            }
        }

    }
}